import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { Router } from '@angular/router'
import { PermissionService } from '@core/auth/services/permission.service'
import { ButtonDirective } from 'primeng/button'
import { Tooltip } from 'primeng/tooltip'

@Component({
  selector: 'albert-ch-cta-btn',
  imports: [
    ButtonDirective,
    Tooltip
  ],
  templateUrl: './certificate-holder-cta-btn.component.html',
  styleUrl: './certificate-holder-cta-btn.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class CertificateHolderCtaButtonComponent {
  protected readonly router = inject(Router)
  protected readonly permissionService = inject(PermissionService)
}
